import { Box } from "@mui/material";
import { ReactNode } from "react";

type BoZoneCalloutProps = {
  children: ReactNode;
};

export const BoZoneCallout = (props: BoZoneCalloutProps) => (
  <Box
    padding="1.5rem"
    borderRadius="1rem"
    sx={{
      background:
        "repeating-linear-gradient(-45deg, #F5F7FC 0px 5px, #EFF1FA 5px 6px)",
    }}
  >
    {props.children}
  </Box>
);
